import { render } from "./Trimmer.vue?vue&type=template&id=64b5a099&scoped=true"
import script from "./Trimmer.vue?vue&type=script&lang=js"
export * from "./Trimmer.vue?vue&type=script&lang=js"

import "./Trimmer.vue?vue&type=style&index=0&id=64b5a099&scoped=true&lang=scss"

import exportComponent from "D:\\www\\Centroid\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b5a099"]])

export default __exports__